import { create } from "zustand"
import type { FarmResponse } from "@/shared/types/api"

interface FarmState {
  selectedFarm: FarmResponse | null
  setSelectedFarm: (farm: FarmResponse | null) => void
  clearFarm: () => void
}

/**
 * Zustand store for farm selection state
 * Note: localStorage operations for farm/pond IDs are handled in hooks (useUrlSync, useValidatedPondId)
 * where we have access to the user ID for user-scoped storage keys
 */
export const useFarmStore = create<FarmState>((set) => ({
  selectedFarm: null,
  setSelectedFarm: (farm) => {
    set({ selectedFarm: farm });
  },
  clearFarm: () => {
    set({ selectedFarm: null });
  },
}))
